import { mergeAttributes, Node } from "@tiptap/core";

import { NWStepProps } from "./index.tsx";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    nwStep: {
      setNWStep: (options: NWStepProps) => ReturnType;
    };
  }
}

export const NWStepAdapter = Node.create<NWStepProps>({
  name: "nw-step",
  group: "inline",
  content: "inline*",
  marks: "highlight",
  inline: true,
  draggable: false,
  selectable: false,
  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },
      title: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "nw-step",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["nw-step", mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("nw-step");
      dom.setAttribute("id", node.attrs.id || "");
      dom.setAttribute("title", node.attrs.title || "");

      const contentDOM = document.createElement("span");
      contentDOM.textContent = node.textContent;
      dom.appendChild(contentDOM);

      return { dom, contentDOM };
    };
  },

  addCommands() {
    return {
      setNWStep:
        options =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },
});
